import qs from "qs";
import { useAuth } from "../hooks/Auth";
import { SKTProgressBar } from "../components/SKTProgressBar";
import { useState } from "react";
import { UserProfile } from "./profile/UserProfile";
import { LoginForm } from "./profile/LoginForm";
import { apiGET, apiPOST } from "../hooks/APIHook";
import { RegisterDone, RegisterForm } from "./profile/RegisterForm";
import { ForgotPasswordRequestForm } from "./profile/ForgotPassword";
import { ActivateLoginView } from "./profile/ActivateLoginView";
import { API_ENDPOINTS } from "../config";
import { getFromQueryString } from "../utils/queryString";
import { ChangePasswordForm } from "./profile/ChangePassword";

export const ProfileView = ({ skt }) => {
  const { auth, refresh } = useAuth();
  const [view, setView] = useState(
    skt.view ?? getFromQueryString("v") ?? "login"
  );
  const [loginStatus, setLoginStatus] = useState("");
  const [registerStatus, setRegisterStatus] = useState({ status: "not_done" });

  const doLogin = (username, password) => {
    apiPOST(API_ENDPOINTS.auth.login, qs.stringify({ username, password }))
      .then((result) => {
        const status = result.data.status;
        if (status === "ok") {
          if (result.data.mode === "corporate") {
            window.location.href = "/tavarakuljetukset-yritykset/";
          } else {
            window.location.href = "/tavarakuljetukset/";
          }
          refresh();
          setView("profile");
        }
        if (status === "fail") {
          if (result.data.reason === "auth")
            setLoginStatus("Käyttäjätunnus ja salasana ei täsmää.");
          else
            setLoginStatus(
              "Kirjautuminen ei onnistunut. Ota yhteyttä asiakaspalveluun, mikäli ongelma jatkuu"
            );
        }
        if (status === "disabled") {
          setLoginStatus(
            "Käyttäjätunnus on suljettu. Jos olet juuri luonut tunnuksesi, sinun tulee vahvistaa sähköpostiosoitteesi ensin!"
          );
        }
        if (status === "redir") {
          window.location.href = result.data.redir;
        }
      })
      .catch((error) => {
        setLoginStatus(`Palvelinvirhe: ${error}`);
      });
  };

  const goLogin = (status) => {
    setLoginStatus(status ?? "");
    setView("login");
  };

  const goForgot = () => {
    setView("forgot");
  };

  const goRegister = () => {
    setView("register");
  };

  const doLogout = (reason = "Olet kirjautunut ulos.") => {
    apiGET(API_ENDPOINTS.auth.logout).then((result) => {
      setLoginStatus(reason);
      refresh();
      setView("login");
      setLoginStatus(reason);
    });
  };

  const doRegister = (values) => {
    apiPOST(API_ENDPOINTS.auth.createAccount, qs.stringify(values)).then(
      (result) => {
        if (result.data.status === "fail") {
          console.log("register status", result);
          setRegisterStatus(result.data);
          if (result.data.reason === "user_creation") {
            alert(
              "Samalla käyttäjätunnuksella on jo olemassa tunnus palvelussa."
            );
          } else {
            alert(
              "Tunnuksen luomisessa tapahtui virhe. Ota yhteyttä asiakaspalveluun!"
            );
          }
        }
        if (result.data.status === "ok") {
          setLoginStatus(
            "Uusi käyttäjätunnus on luotu. Voit kirjautua uusilla tunnuksilla tästä:"
          );
          setView("registerDone");
        }
      }
    );
  };

  const doRequestPasswordReset = (email) => {
    apiGET(API_ENDPOINTS.auth.requestPasswordReset, {
      params: { username: email },
    }).then((result) => {
      setLoginStatus(
        "Mikäli annetulla sähköpostiosoitteella on olemassa käyttäjätunnus, ohjeet salasanan vaihtamiseen on lähetetty annettuun sähköpostiosoitteeseen"
      );
      setView("login");
    });
  };

  if (view === "forgot")
    return (
      <ForgotPasswordRequestForm
        doRequestPasswordReset={doRequestPasswordReset}
      />
    );

  if (view === "change") return <ChangePasswordForm doLogout={doLogout} />;

  if (view === "registerDone")
    return (
      <RegisterDone
        doReturn={() => {
          setView("login");
        }}
      />
    );

  if (view === "register")
    return (
      <RegisterForm registerStatus={registerStatus} doRegister={doRegister} />
    );

  if (view === "profile") {
    if (auth.status === "pending")
      return <SKTProgressBar label="Tietoja haetaan" />;

    if (auth.status === "error") {
      goLogin("Ongelma yhteydessä palvelimeen, yritä myöhemmin uudestaan!");
      return <div>Palvelinvirhe!</div>;
    }

    if (auth.auth) return <UserProfile auth={auth} doLogout={doLogout} />;

    setView("login");
  }

  if (view === "activate") return <ActivateLoginView goLogin={goLogin} />;

  if (view === "login") {
    if (auth.auth) setView("profile");
    return (
      <LoginForm
        login={doLogin}
        goForgot={goForgot}
        goRegister={goRegister}
        status={loginStatus}
      />
    );
  }
};
